export const PREMIUM_FEATURE_KEYS = ['fullaccess', 'export', 'editor', 'media', 'ai'];

export const PREMIUM_PLAN_DEFS = [
  { price: 1490, months: 3, planKey: 'plan3' },
  { price: 2490, months: 6, planKey: 'plan6' },
  { price: 3990, months: 12, planKey: 'plan12' },
];

export function savingsPercentVsBaseline(perMonth, baselinePerMonth) {
  if (perMonth >= baselinePerMonth) return null;
  return Math.round((1 - perMonth / baselinePerMonth) * 100);
}

export function formatRub(n) {
  return new Intl.NumberFormat('ru-RU').format(n);
}

export function buildPremiumPlans(t) {
  const baselinePlan = PREMIUM_PLAN_DEFS[0];
  const baselinePerMonth = baselinePlan ? Math.round(baselinePlan.price / baselinePlan.months) : 0;

  return PREMIUM_PLAN_DEFS.map(({ price, months, planKey }) => {
    const perMonth = Math.round(price / months);
    const pct = savingsPercentVsBaseline(perMonth, baselinePerMonth);
    const badgeLabel =
      pct != null && pct > 0
        ? t('premium.savingsBadge', { percent: pct, price: formatRub(perMonth) })
        : null;
    return {
      title: t(`premium.${planKey}`),
      price,
      months,
      perMonth,
      badgeLabel,
      planKey,
    };
  });
}
